import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Platform } from 'sofa-reborn-react';

function getStyledCoverStyle(platform: Platform): string {
	return `
		width: max-content;
		height: 100%;
		align-items: center;
		max-width: ${platform === 'kiosk' ? '210px' : '144px'};
		justify-content: left;
	`;
}

export const StyledSpan = styled.div<{
	color: string;
	borderColor: string;
	platform: Platform;
}>`
	${(props): string => `
		background-color: ${props.color};
		border-radius: 50%;
		display: inline-block;
		border: 2px solid ${SkapaTheme.color.neutral.white};

		&:not(.active) {
			height: ${props.platform === 'kiosk' ? '36px' : '24px'};
			width: ${props.platform === 'kiosk' ? '36px' : '24px'};
			border: ${props.borderColor ? '1px solid ' + props.borderColor : 'none'};
		}

		&.active {
			height: ${props.platform === 'kiosk' ? '32px' : '20px'};
			width: ${props.platform === 'kiosk' ? '32px' : '20px'};
			box-shadow: 0 0 0 2px ${SkapaTheme.color.semantic.informative};
		}
	`};
`;

export const StyledCover = styled.div<{
	platform: Platform;
}>`
	display: flex;
	flex-wrap: wrap;
	${(props) => getStyledCoverStyle(props.platform)}
`;

export const StyledSpanWrapper = styled.div<{
	platform: Platform;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${(props) => (props.platform === 'kiosk' ? '70px' : '48px')};
	width: ${(props) => (props.platform === 'kiosk' ? '70px' : '48px')};
	cursor: pointer;
`;
